export interface SiteSettingsSettings {
  version?: number
  defaultWidgetType?: string
  firstTimeCompleted?: boolean
  pageEnabled?: boolean
  pagesType?: PagesType
  pageUpgradeShown?: boolean
  upgradePending?: boolean
}

export interface SiteSettings extends wix.events.editor.SiteSettings {
  settings: SiteSettingsSettings
  demo: boolean
}

export enum PagesType {
  DETAILS_PAGE_ENABLED = 1,
  DETAILS_PAGE_DISABLED = 2
}
